import { TableState, TableStateChangeFns } from "@/zustand/slices/tables";
import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

type LeadsInCalculationTablesState = Record<number, TableState>;

export type LeadsInCalculationTablesSlice = {
  leadTables: LeadsInCalculationTablesState;
  addLeadTable: (tableId: number) => void;
  getLeadTableStateChangeFns: (
    tableId: keyof LeadsInCalculationTablesState
  ) => TableStateChangeFns;
};

const initialState: LeadsInCalculationTablesState = {};

const leadInCalculationTableState: TableState = {
  columnOrder: [
    "leadId",
    "product",
    "firstName",
    "lastName",
    "birthDate",
    "createdAt",
    "agent",
    "realizedAmount",
    "netoRealizedAmount",
    "deduction",
    "currency",
    "realizedAt",
    "partnerCommission",
    "requestStatus",
    "included",
    "payrollType",
    "agentCode",
  ],
  columnWidths: [
    { columnName: "leadId", width: 150 },
    { columnName: "firstName", width: 150 },
    { columnName: "lastName", width: 150 },
    { columnName: "birthDate", width: 200 },
    { columnName: "realizedAt", width: 200 },
    { columnName: "realizedAmount", width: 150 },
    { columnName: "currency", width: 150 },
    { columnName: "partnerCommission", width: 150 },
    { columnName: "createdAt", width: 200 },
    { columnName: "included", width: 200 },
    { columnName: "payrollType", width: 200 },
    { columnName: "requestStatus", width: 200 },
    { columnName: "netoRealizedAmount", width: 200 },
    { columnName: "deduction", width: 200 },
    { columnName: "agent", width: 250 },
    { columnName: "product", width: 150 },
    { columnName: "agentCode", width: 250 },
  ],
  filters: [],
  grouping: [{ columnName: "product" }],
  hiddenColumnNames: [],
  selection: [],
  sorting: [],
  search: "",
  expandedGroups: [],
  expandedRowIds: [],
};

export const createLeadsInCalculationTablesSlice: StateCreator<
  Store,
  [],
  [],
  LeadsInCalculationTablesSlice
> = (set, get) => ({
  leadTables: initialState,
  addLeadTable: (tableId) => {
    if (!(tableId in get().leadTables)) {
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: leadInCalculationTableState,
        },
      }));
    }
  },
  getLeadTableStateChangeFns: (tableId) => ({
    onSelectionChange: (selection) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], selection },
        },
      })),
    onColumnOrderChange: (columnOrder) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], columnOrder },
        },
      })),
    onColumnWidthsChange: (columnWidths) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], columnWidths },
        },
      })),
    onExpandedGroupsChange: (expandedGroups) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], expandedGroups },
        },
      })),
    onExpandedRowIdsChange: (expandedRowIds) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], expandedRowIds },
        },
      })),
    onFiltersChange: (filters) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], filters },
        },
      })),
    onGroupingChange: (grouping) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], grouping },
        },
      })),
    onHiddenColumnNamesChange: (hiddenColumnNames) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], hiddenColumnNames },
        },
      })),
    onSearchChange: (search) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], search },
        },
      })),
    onSortingChange: (sorting) =>
      set((state) => ({
        leadTables: {
          ...state.leadTables,
          [tableId]: { ...state.leadTables[tableId], sorting },
        },
      })),
  }),
});
